import '../style.css';
import {AppComponent} from "@/components/app-component";
import proj4 from 'proj4';
import {register} from 'ol/proj/proj4';
import {getCategoryName, getWebsiteName, getWebsiteUrl} from "@/helpers/url-helper";
import $ from 'jquery/dist/jquery'

window.kaartViewerUrl = getWebsiteUrl()
window.websiteName = getWebsiteName()
window.categoryName = getCategoryName()

$('head').append('<link rel="stylesheet" href="' + window.kaartViewerUrl + '/admin/rest/openapi/' + window.websiteName + '/style.css?time=' + new Date().getTime() + '" type="text/css" />');

proj4.defs('EPSG:28992','+proj=sterea +lat_0=52.15616055555555 +lon_0=5.38763888888889 +k=0.9999079 +x_0=155000 +y_0=463000 +ellps=bessel +towgs84=565.417,50.3319,465.552,-0.398957,0.343988,-1.8774,4.0725 +units=m +no_defs');
register(proj4);

AppComponent.defineElements();

var link = document.querySelector("link[rel~='icon']");
if (!link) {
    link = document.createElement('link');
    link.rel = 'icon';
    document.getElementsByTagName('head')[0].appendChild(link);
}
link.href = window.kaartViewerUrl + '/admin/rest/kaartviewerapi/menu/icon';
